module.exports = __webpack_public_path__ + "img/1533119478.303f882f.jpg";